import { ReactNode } from 'react'
import { LucideIcon } from 'lucide-react'

interface SectionHeaderProps {
  icon?: LucideIcon
  title: string
  iconSize?: 'sm' | 'md'
  children?: ReactNode
}

export const SectionHeader = ({
  icon: Icon,
  title,
  iconSize = 'sm',
  children
}: SectionHeaderProps) => {
  const iconClass = iconSize === 'sm' ? 'h-4 w-4' : 'h-5 w-5'

  return (
    <h2 className="flex items-center justify-between text-base font-semibold md:text-lg">
      <div className="flex items-center gap-2">
        {Icon && <Icon className={iconClass} />}
        <span>{title}</span>
      </div>
      {children}
    </h2>
  )
}
